/**
 * API DateTime kolonlarını doğru okumak için ortak yardımcı.
 *
 * SORUN:
 * Veritabanındaki `datetime` kolonları saat dilimi bilgisi taşımıyor. Mobil
 * uygulama ve panel bu kolonlara UTC yazıyor (`new Date().toISOString()`),
 * ancak Web API (OData) serileştirirken naive değeri SUNUCUNUN yerel saat
 * dilimiyle etiketliyor:
 *
 *   DB'de yazan : 2026-08-14 17:17:46   (aslında UTC)
 *   API'nin dönüşü: 2026-08-14T17:17:46+03:00
 *
 * `new Date(...)` bu etiketi doğru kabul edip 17:17 gösteriyor; oysa kaydın
 * gerçek Türkiye saati 20:17. Sonuç: panelde tüm ilan/teklif saatleri tam
 * 3 saat geriden görünüyor.
 *
 * ÇÖZÜM:
 * Etiketi (Z ya da ±HH:MM) at, kalan saat rakamlarını UTC kabul et. Tarayıcı
 * `toLocaleString` ile bunu izleyicinin saatine (TR'de UTC+3) çevirir.
 *
 * NOT: Kalıcı çözüm API tarafındadır — OData serileştiricisi UTC'ye alınmalı
 * (`config.SetTimeZoneInfo(TimeZoneInfo.Utc)`) ve sunucudaki `DateTime.Now`
 * yazımları `DateTime.UtcNow`'a çevrilmelidir. O yapıldığında bu yardımcı
 * çalışmaya aynen devam eder (etiket `Z` olur, sonuç değişmez).
 */

/** API'den gelen datetime değerini Date'e çevirir (naive-UTC kabulüyle). */
export const parseApiDate = (raw) => {
  if (!raw) return null;
  if (raw instanceof Date) return Number.isNaN(raw.getTime()) ? null : raw;
  const s = String(raw).trim().replace(/(?:[Zz]|[+-]\d{2}:?\d{2})$/, "");
  const d = new Date(s + "Z");
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "14.08.2026 20:17" biçimi. */
export const formatApiDateTime = (raw, fallback = "-") => {
  const d = parseApiDate(raw);
  return d ? d.toLocaleString("tr-TR") : fallback;
};

/** "14.08.2026" biçimi. */
export const formatApiDate = (raw, fallback = "-") => {
  const d = parseApiDate(raw);
  return d ? d.toLocaleDateString("tr-TR") : fallback;
};

/** "14.08.2026 20:17" (saniyesiz) biçimi. */
export const formatApiDateShort = (raw, fallback = "-") => {
  const d = parseApiDate(raw);
  if (!d) return fallback;
  return `${d.toLocaleDateString("tr-TR")} ${d.toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};
